import { render } from "./Restore.vue?vue&type=template&id=6bd87959"
import script from "./Restore.vue?vue&type=script&lang=js"
export * from "./Restore.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__